import React, { useState, useEffect, useCallback } from 'react'; // Import useCallback

function IletisimSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    '/collect/959-slider-panolux-6899.jpg',
    '/collect/959-slider-panolux-6837.jpg',
    '/collect/959-slider-panolux-6857.jpg',
    '/collect/959-slider-panolux-6832.jpg'
  ];
  const intervalTime = 3000; // Zeit in Millisekunden, nach der zum nächsten Bild gewechselt wird

  // Memoize goToNext to prevent it from recreating on every render
  const goToNext = useCallback(() => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, images.length]); // Dependencies for useCallback

  // Memoize goToPrevious as well, for consistency and good practice
  const goToPrevious = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, images.length]); // Dependencies for useCallback


  useEffect(() => {
    const intervalId = setInterval(() => {
      goToNext();
    }, intervalTime);

    return () => clearInterval(intervalId); // Cleanup Funktion, um den Interval zu stoppen, wenn die Komponente unmounted wird
  }, [goToNext, intervalTime]); // Now 'goToNext' is a stable dependency thanks to useCallback

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-8">
      <h2 className="text-3xl font-light text-center text-gray-800 mb-8">Panolux'e yakından bakmak</h2>

      {/* Slider Carousel */}
      <div className="relative w-full max-w-4xl h-[34rem] overflow-hidden rounded-lg shadow-lg mb-12">
        {/* Slider Image */}
        {images.map((image, index) => (
          <img
            key={index} // Her eleman için benzersiz bir "key" eklemeyi unutmayın
            src={image}
            alt={`Slide ${index + 1}`}
            // Yeni animasyon sınıfları burada!
            className={`absolute top-0 left-0 w-full h-full object-cover transition-all duration-700 ease-in-out
              ${index === currentIndex ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
            // `scale-105` ile hafifçe büyüme efekti veriyoruz.
          />
        ))}


        {/* Left Arrow */}
        <button
          onClick={goToPrevious}
          className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white bg-opacity-50 text-gray-800 p-3 hover:bg-opacity-75 focus:outline-none z-10"
        >
          &lt;
        </button>

        {/* Right Arrow */}
        <button
          onClick={goToNext}
          className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white bg-opacity-50 text-gray-800 p-3 hover:bg-opacity-75 focus:outline-none z-10"
        >
          &gt;
        </button>
      </div>

      {/* Three-Column Paragraph Structure */}
      <div className="w-full max-w-4xl grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        {/* Column 1 - Havacılıkta Panolux */}
        <div className="">
          <h3 className="text-md text-center font-tihn text-gray-800 mb-3">Havacılıkta Panolux</h3>
          <p className="text-gray-700 leading-6 font-thin text-center text-[0.9rem]">
            Panolux, çok yüksek mukavemet ve bina güvenliği sağlayarak büyük hacimli havacılık binalarının vazgeçilmez yapı malzemeleri arasına girmiştir. IEE 1502-2007, MILSTD 285 ve IEEE 299 standartlarına göre anti-radar özelliğine sahip olan Panolux; havalimanı terminallerinde, uçak ve helikopter hangarlarında ve havacılık endüstrisi binalarında kullanılabilir.
          </p>
        </div>

        {/* Column 2 - Konut Dışı Projelerde Panolux */}
        <div className="">
          <h3 className="text-md text-center font-tihn text-gray-800 mb-3">Konut Dışı Projelerde Panolux</h3>
          <p className="text-gray-700 leading-6 font-thin text-center text-[0.9rem]">
            9.5 metreye kadar serbest boyda üretilebilen Panolux, hafifliği ve dayanıklılığıyla konut dışı projelerde iç ve dış kullanımda geniş olanaklar sunar. Kurumsal projeler için tüm Pantone® ve RAL® renklerde üretilebilen Panolux; gar, otogar, metro vb. ulaşım terminallerinde, tersane, iskele ve denizcilik terminallerinde, banka, AVM, otel ve iş merkezlerinde, sanayi tesislerinde ve çok geniş açıklıklı kapı projelerinde kullanılabilir.
          </p>
        </div>

        {/* Column 3 - Konut Projelerinde Panolux */}
        <div className="">
          <h3 className="text-md text-center font-tihn text-gray-800 mb-3">Konut Projelerinde Panolux</h3>
          <p className="text-gray-700 leading-6 font-thin text-center text-[0.9rem]">
            Konut projelerinde tasarımcılara çok büyük esneklik sağlayan Panolux, yapıları ışıkla çok kolay buluşturan bir malzemedir. Kolay işlenebilen ve bina yükünü artırmayan Panolux, müstakil ve çok katlı konut projelerinde; kış bahçesi, limonluk vb. hacimlerde, iç seperasyonlarda, ışık girmesi istenen duvar, tavan ve çatı uygulamalarında kullanılabilir.
          </p>
        </div>
      </div>

      {/* Existing İletişim Content - Adjusted position if needed */}
      <p className="mt-8 text-lg text-gray-600 text-center">Panolux hakkında daha fazla bilgi almak için bizimle iletişime geçin.</p>
    </div>
  );
}

export default IletisimSection;